/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Spin-Alt': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<defs><path pid="0" d="M14 2.75c6.116 0 11.092 4.88 11.246 10.96l.004.29h-2.5a8.75 8.75 0 10-9.008 8.746l.258.004v2.5C7.787 25.25 2.75 20.213 2.75 14S7.787 2.75 14 2.75z" id="svgicon_Spin-Alt_a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_Spin-Alt_b" _fill="#fff"><use xlink:href="#svgicon_Spin-Alt_a"/></mask><use _fill="#000" fill-rule="nonzero" xlink:href="#svgicon_Spin-Alt_a"/><g mask="url(#svgicon_Spin-Alt_b)" _fill="#2D75F5"><path pid="1" d="M1.273 1.273h25.455v25.455H1.273z"/></g></g>'
  }
})
